import React, { Fragment } from 'react';
import { resolve } from 'library/helpers/path-resolver';
import { Switch, Route, Link, Redirect } from 'library/util/core-router';
import { ShimmyValue } from 'library/components/shimmy';
import HiringQuery from 'apps/hiring/util/query';
import withData from 'util/hoc/with-data';
import HiringDashboard from 'apps/hiring/components/hiring-dashboard';
import InviteModal from 'apps/hiring/components/invite-modal';
import OpeningNavigation from 'apps/hiring/components/opening-navigation';
import SurveyStatus from 'apps/hiring/components/survey-status';
import Loading from 'components/loading';
import Evaluate from 'apps/hiring/components/evaluate';
import Settings from 'apps/hiring/sections/opening/settings';
import Applicant from 'apps/hiring/sections/applicant';
import OpeningCharts from 'apps/hiring/components/opening-charts';

class Opening extends React.Component {
  render() {
    const {
      graph_data,
      graph_loading,
      reload_graph
    } = this.props;

    if (graph_loading) {
      return <Loading />
    }

    return (
      <Fragment>
        <ShimmyValue namespace="hiring-breadcrumbs">
          <Link to="/hiring/openings" key="application">Openings</Link>
          <Link to={`/hiring/openings/${resolve(graph_data, 'opening/id', '')}/evaluate`} key="opening">{resolve(graph_data, 'opening/name', '')}</Link>
        </ShimmyValue>
        <ShimmyValue namespace="hiring-navigation-buttons">
          <InviteModal type="opening" opening={graph_data.opening} />
        </ShimmyValue>
        <div className="hiring-body">
          <Route
            path="/hiring/openings/:id"
            component={OpeningNavigation}
          />
          <section className="hiring-section">
            <Switch>
              <Route path="/hiring/openings/:openingId/applicants/:applicantId"
                component={Applicant}
              />
              <Route path="/hiring/openings/:id/evaluate/:target?"
                component={Evaluate}
              />
              <Route path='/hiring/openings/:id/dashboard'
                component={HiringDashboard}
              />
              <Route path="/hiring/openings/:id/charts"
                component={OpeningCharts}
              />
              <Route path="/hiring/openings/:id/surveys"
                component={SurveyStatus}
              />
              <Route path="/hiring/openings/:id/settings"
                render={(props)=>(
                  <Settings reloadOpening={reload_graph} {...props} />
                )}
              />
              <Route path="/hiring/openings/:id"
                component={Evaluate}
              />
            </Switch>
          </section>
        </div>
      </Fragment>
    );
  }
}

Opening.dependantPropPath = 'match/params/id';

Opening.query = (token, { match }) => (
  HiringQuery(`
    {
      opening (id: ${match.params.id}) {
        id,
        name,
        closed,
        settings {
          invitation_token
        }
      }
    }
  `)
);

export default withData(Opening);
